import * as React from 'react';
import Dropzone from 'react-dropzone';
import { Environment } from '../../../../const/environment';
import { ImportFilesMode } from '../../../../const/ImportFilesMode';
import { IProject } from '../../../../models/IProject';
import { IImportFilesParam } from '../../../../redux/projects/saga.projects';
import { confirmAlert } from '../../../../services/mini/alanConfirmAlert';
import ConfirmPopup from '../../../components/ConfirmPopup/ConfirmPopup';


type ScriptsDropZoneProps = {
    project: IProject
    environment: Environment
    importConflictScripts: string[]
    noClick?: boolean
    noKeyboard?: boolean
    importFiles: (param: IImportFilesParam) => void
    onDropAccepted?: () => void
    onFileDialogCancel?: () => void
}

type ScriptsDropZoneState = {
    files: any[]
}


export class ScriptsDropZone extends React.Component<ScriptsDropZoneProps, ScriptsDropZoneState> {

    constructor(props) {
        super(props);

        this.state = {
            files: [],
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            this.state.files &&
            this.state.files.length &&
            this.props.importConflictScripts &&
            this.props.importConflictScripts.length &&
            this.props.importConflictScripts !== prevProps.importConflictScripts
        ) {
            this.showConfirmModal();
        }
    }

    onDrop = (files) => {
        this.setState({
            files,
        }, () => {
            this.importFiles();
            if(this.props.onDropAccepted){
                this.props.onDropAccepted();
            }
        });
    };

    importFiles = (importMode = ImportFilesMode.Default) => {
        const { environment, importFiles } = this.props;

        importFiles({
            project: this.props.project,
            files: this.state.files,
            importMode,
            environment
        });
    };

    onClose = () => {
        this.setState({ files: [] });
    };

    showConfirmModal = () => {
        confirmAlert({
            customUI: ({ onClose }) => {
                const msg = <div>Your project already contains these scripts: {this.props.importConflictScripts.map((script, i) => <b key={script}>
                    {script}{i === this.props.importConflictScripts.length - 1 ? '. ' : ', '}
                </b>)} Would you like to replace existing scripts?
                </div>;
                return (
                    <ConfirmPopup
                        onClose={onClose}
                        okBtnLabel="Replace"
                        midBtnLabel="Don't replace"
                        okBtnCb={() => {
                            this.importFiles(ImportFilesMode.Replace);
                            onClose();
                        }}
                        midBtnCb={() => {
                            this.importFiles(ImportFilesMode.SkipConflicts);
                            onClose();
                        }}
                        title="Import Scripts"
                        message={msg}
                    />
                );
            },
            onClose: this.onClose,
        });
    };


    render() {
        const { noClick, noKeyboard, onFileDialogCancel, onDropAccepted } = this.props;
        return (
            <Dropzone 
                onDrop={this.onDrop} 
                noClick={noClick}
                noKeyboard={noKeyboard}
                onFileDialogCancel={onFileDialogCancel} 
                onDropAccepted={onDropAccepted}>
                {({ getRootProps, getInputProps, isDragActive }) => (
                    <div className={`scripts-drop-zone ${isDragActive && 'active'}`} {...getRootProps()}>
                        <input {...getInputProps()} />
                        {this.props.children}
                    </div>
                )}
            </Dropzone>
        );
    }
}
